import React from 'react';

import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';

import PageWithHeader from 'layouts/PageWithHeader/PageWithHeader';
import { LinkComponent } from 'components';
import { ROUTES } from 'routes/constants';

import { TrafficRedirect } from './TrafficRedirect/TrafficRedirect';

export const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <PageWithHeader tabTitle="neki" headerText={t('pages.manageMaintenance.title')}>
      <Grid container spacing={4} direction="column">
        <Grid item>
          <TrafficRedirect />
        </Grid>
        <Grid item>
          <LinkComponent to={ROUTES.migrationReports}>{t('pages.migrationReports.title')}</LinkComponent>
        </Grid>
      </Grid>
    </PageWithHeader>
  );
};
